<p>base-info-rental works!</p>
